(() => {
  'use strict';

  const SELECTORS = {
    account: '.section-header .header__icon--account',
    header: '.section-header',
    headerRow: '.section-header .header.page-width',
    icons: '.section-header .header__icons',
    bridge: '#GowinStoreCreditBridge'
  };

  const mobileMedia = window.matchMedia('(max-width: 989px)');
  let originalAccountParent = null;
  let originalAccountNextSibling = null;

  const readCreditState = () => {
    const bridge = document.querySelector(SELECTORS.bridge);

    return {
      authenticated: bridge?.dataset.authenticated === 'true',
      balance: String(bridge?.dataset.balance || '').trim() || '₡0'
    };
  };

  const rememberDesktopPosition = (account) => {
    if (originalAccountParent || !account?.parentElement) return;
    originalAccountParent = account.parentElement;
    originalAccountNextSibling = account.nextSibling;
  };

  const placeAccount = (account) => {
    if (!account) return;

    const headerRow = document.querySelector(SELECTORS.headerRow);
    const icons = document.querySelector(SELECTORS.icons);
    if (!headerRow || !icons) return;

    rememberDesktopPosition(account);

    if (mobileMedia.matches) {
      if (account.parentElement !== headerRow) {
        headerRow.insertBefore(account, icons);
      }
      return;
    }

    const targetParent = originalAccountParent?.isConnected ? originalAccountParent : icons;
    if (account.parentElement === targetParent) return;

    const next = originalAccountNextSibling;
    if (next?.isConnected && next.parentElement === targetParent) {
      targetParent.insertBefore(account, next);
      return;
    }

    const fallback = targetParent.querySelector('.gowin-search-toggle, .header__icon--cart');
    targetParent.insertBefore(account, fallback || null);
  };

  const syncAccount = () => {
    const account = document.querySelector(SELECTORS.account);
    if (!account) return;

    const state = readCreditState();
    if (!state.authenticated) return;

    rememberDesktopPosition(account);

    const existingAmount = account.querySelector('.gowin-account-credit__amount');

    if (existingAmount) {
      if (existingAmount.textContent !== state.balance) {
        existingAmount.textContent = state.balance;
      }

      account.setAttribute(
        'aria-label',
        `Tu cuenta. Recompensas disponibles ${state.balance}. Abrir cuenta`
      );
      account.title = `Recompensas disponibles: ${state.balance}`;
      placeAccount(account);
      return;
    }

    const icon = account.querySelector('account-icon, .svg-wrapper');
    const iconClone = icon?.cloneNode(true) || null;

    const copy = document.createElement('span');
    copy.className = 'gowin-account-credit__copy';

    const label = document.createElement('span');
    label.className = 'gowin-account-credit__label';
    label.textContent = 'RECOMPENSAS';

    const balanceRow = document.createElement('span');
    balanceRow.className = 'gowin-account-credit__balance';

    const balanceLabel = document.createElement('span');
    balanceLabel.textContent = 'Saldo';

    const amount = document.createElement('strong');
    amount.className = 'gowin-account-credit__amount';
    amount.textContent = state.balance;

    balanceRow.append(balanceLabel, amount);
    copy.append(label, balanceRow);

    account.replaceChildren();

    if (iconClone) {
      account.appendChild(iconClone);
    }

    account.appendChild(copy);
    account.classList.add('gowin-account-credit');
    account.setAttribute(
      'aria-label',
      `Tu cuenta. Recompensas disponibles ${state.balance}. Abrir cuenta`
    );
    account.title = `Recompensas disponibles: ${state.balance}`;
    placeAccount(account);
  };

  let syncTimer = 0;

  const scheduleSync = () => {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncAccount, 30);
  };

  const observeHeader = () => {
    const header = document.querySelector(SELECTORS.header);

    if (!header || header.dataset.gowinCreditObserved === 'true') {
      return;
    }

    header.dataset.gowinCreditObserved = 'true';

    new MutationObserver(scheduleSync).observe(header, {
      childList: true,
      subtree: true
    });
  };

  const boot = () => {
    syncAccount();
    observeHeader();
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot, { once: true })
    : boot();

  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('pageshow', scheduleSync);

  if (typeof mobileMedia.addEventListener === 'function') {
    mobileMedia.addEventListener('change', scheduleSync);
  } else {
    mobileMedia.addListener(scheduleSync);
  }
})();
